import { render, staticRenderFns } from "./TaskStatus.vue?vue&type=template&id=8a0c4c66&scoped=true"
import script from "./TaskStatus.vue?vue&type=script&lang=js"
export * from "./TaskStatus.vue?vue&type=script&lang=js"
import style0 from "./TaskStatus.vue?vue&type=style&index=0&id=8a0c4c66&prod&lang=less&scoped=true"
import style1 from "./TaskStatus.vue?vue&type=style&index=1&id=8a0c4c66&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a0c4c66",
  null
  
)

export default component.exports